<template>
  <content-main>
    <content-item class="episodes">
      <a
          class="btn btn_action btn_delete"
          title="Smazat všechny epizody"
          @click.prevent="$emit('deleteAll')"
          v-if="Object.keys(series).length > 0"
      >Smazat všechny epizody</a>
      <ul
          v-if="!pending && seriesNum !== 'null'"
          v-for="seriesNum in Object.keys(series)"
          :key="`series-${seriesNum}`"
      >
        <li>
          <strong>
            <translate>Série</translate> {{ seriesNum.padStart(2, '0') }}
            <a
                class="btn btn_action btn_delete"
                title="Smazat sérii"
                @click.prevent="$emit('deleteSeries', seriesNum)"
            >Smazat sérii</a>
          </strong>
          <ul>
            <li v-for="ep in series[seriesNum]" :key="ep._id">
              <strong>
                {{ ep.episodeNumber ? `${ep.episodeNumber}. ` : ''}}
                {{ ep.name }}
                <a
                    class="btn btn_action btn_delete"
                    title="Smazat epizodu"
                    @click.prevent="$emit('deleteEpisode', ep._id)"
                >Smazat epizodu</a>
              </strong>
              {{ ep.description }}
            </li>
          </ul>
        </li>
      </ul>
      <ul class="content-series" v-if="!pending" v-for="ep in series['null']" :key="`episode-${ep._id}`">
        <li>
          <strong>
            {{ ep.episodeNumber ? `${ep.episodeNumber}. ` : ''}}
            {{ ep.name }}
            <a
                class="btn btn_action btn_delete"
                title="Smazat epizodu"
                @click.prevent="$emit('deleteEpisode', ep._id)"
            >Smazat epizodu</a>
          </strong>
          {{ ep.description }}
        </li>
      </ul>
      <ul v-if="!pending && Object.keys(series).length === 0">
        <li>
          <translate>Tento pořad neobsahuje žádné epizody.</translate>
        </li>
      </ul>
    </content-item>
  </content-main>
</template>

<script>
import ContentMain from './ContentMain'
import ContentItem from './ContentItem'

export default {
  name: 'episodes-main-content',
  components: {
    ContentMain,
    ContentItem
  },
  props: {
    series: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  }
}
</script>
